<template>
	<div class="form-page">

		<div class="pad-20">
			<el-tabs v-model="type" @tab-click="handleClick">
				<el-tab-pane :label="$t('市价委托')" name="1"></el-tab-pane>
				<el-tab-pane :label="$t('限价委托')" name="2"></el-tab-pane>
			</el-tabs>

			<div class="form-div dis-fle">
				<div class="flex-1">
					<div class="form-item">
						<span class="value txt-16">{{ $t('模式') }}</span>
					</div>
					<div class="form-item">
						<el-radio-group v-model="zForm.model" size="mini">
							<el-radio-button :label="0">{{ $t('逐仓') }}</el-radio-button>
							<el-radio-button :label="1">{{ $t('全仓') }}</el-radio-button>
						</el-radio-group>
					</div>
					<div class="form-item">
						<span class="value txt-16">{{ $t('调整杠杆') }}</span>
					</div>
					<div class="form-item">
						<el-radio-group v-model="zForm.lever" size="mini">
							<el-radio-button v-for="item in leverList" :key="item.value" :label="item.value">
								{{ item.title }}</el-radio-button>
						</el-radio-group>
					</div>
					<div class="form-item">
						<el-input v-model="zForm.limit_price" :placeholder="type == 1 ? $t('以当前市场最优价格下单') : $t('请输入')"
							:disabled="type == 1" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('价格') }}(USDT)</span>
							<span v-if="type == 2" slot="append" class="txt-14">{{ $t('对手价') }}</span>
						</el-input>
					</div>
					<div class="form-item">
						<el-input v-model="zForm.number" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('数量') }}(USDT)</span>
							<span slot="append" class="txt-14">{{ $t('张') }}</span>
						</el-input>
					</div>
					<div class="form-item slider-div">
						<el-slider v-model="zForm.slider" :marks="marks"></el-slider>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('可用') }}</span>
							<span class="value">{{ moneyAccount }} USDT</span>
						</div>
					</div>
					<div class="form-item">
						<el-checkbox v-model="zForm.is_stop_profit">{{ $t('止盈') }}</el-checkbox>
						<el-checkbox v-model="zForm.is_stop_loss">{{ $t('止损') }}</el-checkbox>
					</div>
					<div class="form-item dis-fle ali-cen" v-if="zForm.is_stop_profit">
						<el-input v-model="zForm.stop_profit_price" :placeholder="$t('请输入')" size="medium"
							class="flex-1">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('止盈触发价') }}</span>
						</el-input>
						<el-input v-model="zForm.profit_rate" :placeholder="$t('涨幅')" size="medium"
							class="profit_rate_input" style="width: 150px;margin-left: 16px;">
							<span slot="suffix" class="slot-suffix txt-14">%</span>
						</el-input>
					</div>
					<div class="form-item dis-fle ali-cen" v-if="zForm.is_stop_loss">
						<el-input v-model="zForm.stop_loss_price" :placeholder="$t('请输入')" size="medium" class="flex-1">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('停损触发价') }}</span>
						</el-input>
						<el-input v-model="zForm.loss_rate" :placeholder="$t('跌幅')" size="medium"
							class="profit_rate_input" style="width: 150px;margin-left: 16px;">
							<span slot="suffix" class="slot-suffix txt-14">%</span>
						</el-input>
					</div>
					<!-- <div class="form-item">
						<el-input v-model="zForm.pay_password" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('资金密码') }}</span>
						</el-input>
					</div> -->
					<div class="form-item">
						<div class="but" @click="submit(1)">{{ $t('买进(做多)') }}</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('可开张数') }}</span>
							<span class="value">{{ (moneyAccount / productInfo.price).toFixed(2) }}{{ $t('张') }}</span>
						</div>
					</div>
				</div>
				<div class="flex-1" style="margin-left: 20px;">
					<div class="form-item">
						<span class="value txt-16">{{ $t('模式') }}</span>
					</div>
					<div class="form-item">
						<el-radio-group v-model="dForm.model" size="mini">
							<el-radio-button :label="0">{{ $t('逐仓') }}</el-radio-button>
							<el-radio-button :label="1">{{ $t('全仓') }}</el-radio-button>
						</el-radio-group>
					</div>
					<div class="form-item">
						<span class="value txt-16">{{ $t('调整杠杆') }}</span>
					</div>
					<div class="form-item">
						<el-radio-group v-model="dForm.lever" size="mini">
							<el-radio-button v-for="item in leverList" :key="item.value" :label="item.value">
								{{ item.title }}</el-radio-button>
						</el-radio-group>
					</div>
					<div class="form-item">
						<el-input v-model="dForm.limit_price" :placeholder="type == 1 ? $t('以当前市场最优价格下单') : $t('请输入')"
							:disabled="type == 1" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('价格') }}(USDT)</span>
							<span v-if="type == 2" slot="append" class="txt-14">{{ $t('对手价') }}</span>
						</el-input>
					</div>
					<div class="form-item">
						<el-input v-model="dForm.number" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('数量') }}(USDT)</span>
							<span slot="append" class="txt-14">{{ $t('张') }}</span>
						</el-input>
					</div>
					<div class="form-item slider-div">
						<el-slider v-model="dForm.slider" :marks="marks"></el-slider>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('可用') }}</span>
							<span class="value">{{ moneyAccount }} USDT</span>
						</div>
					</div>
					<div class="form-item">
						<el-checkbox v-model="dForm.is_stop_profit">{{ $t('止盈') }}</el-checkbox>
						<el-checkbox v-model="dForm.is_stop_loss">{{ $t('止损') }}</el-checkbox>
					</div>
					<div class="form-item dis-fle ali-cen" v-if="dForm.is_stop_profit">
						<el-input v-model="dForm.stop_profit_price" :placeholder="$t('请输入')" size="medium"
							class="flex-1">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('止盈触发价') }}</span>
						</el-input>
						<el-input v-model="dForm.profit_rate" :placeholder="$t('涨幅')" size="medium"
							class="profit_rate_input" style="width: 150px;margin-left: 16px;">
							<span slot="suffix" class="slot-suffix txt-14">%</span>
						</el-input>
					</div>
					<div class="form-item dis-fle ali-cen" v-if="dForm.is_stop_loss">
						<el-input v-model="dForm.stop_loss_price" :placeholder="$t('请输入')" size="medium" class="flex-1">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('停损触发价') }}</span>
						</el-input>
						<el-input v-model="dForm.loss_rate" :placeholder="$t('跌幅')" size="medium"
							class="profit_rate_input" style="width: 150px;margin-left: 16px;">
							<span slot="suffix" class="slot-suffix txt-14">%</span>
						</el-input>
					</div>
					<!-- <div class="form-item">
						<el-input v-model="dForm.pay_password" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('资金密码') }}</span>
						</el-input>
					</div> -->
					<div class="form-item">
						<div class="but but1" @click="submit(2)">{{ $t('卖出(做空)') }}</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('可开张数') }}</span>
							<span class="value">{{ (moneyAccount / productInfo.price).toFixed(2) }}{{ $t('张') }}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="tip-div">
				<div class="title txt-16">{{ intro.title }}</div>
				<p v-html="intro.content"> </p>
			</div>
		</div>
	</div>
</template>

<script>

import { mapState } from "vuex";
import { post } from '@/http/request'
import apis from '@/http/api'

class FormData {
	constructor(lever) {
		// product_id 
		// direction 方向:1=买涨,2=买跌,
		// lever 杠杆倍数
		// limit_price 限价
		// type 订单类型:1=市价委托,2=限价委托
		// number 购买张数
		// is_stop_profit 是否止盈1=是，0=否
		// is_stop_loss 是否止损1=是0=否
		// stop_profit_price 止盈价
		// stop_loss_price 止损价
		// profit_rate 涨幅
		// loss_rate 跌幅
		// model 模式0=逐仓1=全仓

		this.slider = 0;
		this.product_id = "";
		this.direction = "";
		this.lever = lever || 10;
		this.limit_price = "";
		this.type = "";
		this.number = "";
		this.is_stop_profit = false;
		this.is_stop_loss = false;
		this.stop_profit_price = 0;
		this.stop_loss_price = 0;
		this.profit_rate = "";
		this.loss_rate = "";
		this.model = 0;
		this.pay_password = "";
	}
}
export default {
	props: {
		productInfo: {
			type: Object,
			default: () => {
				return {}
			}
		},
		moneyAccount: {
			type: Number,
			default: 0
		},
	},
	computed: {
		...mapState(["config"]),
		intro() {
			return this.productInfo.intro_contract || {}
		},
		leverList() {
			const arr = [{
				title: '5X',
				value: 5
			},
			{
				title: '10X',
				value: 10
			},
			{
				title: '20X',
				value: 20
			},
			{
				title: '50X',
				value: 50
			},
			{
				title: '100X',
				value: 100
			}]
			return this.config.contract_lever_config || arr
		},
		lever() {
			return this.leverList[0]?.value || 10
		}
	},
	watch: {
		'productInfo.id'() {
			this.zForm = new FormData(this.lever)
			this.dForm = new FormData(this.lever)
		},
		'zForm.is_stop_profit'() {
			this.zForm.stop_profit_price = 0
			this.zForm.profit_rate = ''
		},
		'zForm.is_stop_loss'() {
			this.zForm.stop_loss_price = 0
			this.zForm.loss_rate = ''
		},
		'dForm.is_stop_profit'() {
			this.dForm.stop_profit_price = 0
			this.dForm.profit_rate = ''
		},
		'dForm.is_stop_loss'() {
			this.dForm.stop_loss_price = 0
			this.dForm.loss_rate = ''
		},
	},
	data() {
		return {
			type: '1',

			zForm: new FormData(),
			dForm: new FormData(),

			marks: {
				0: '0%',
				25: '25%',
				50: '50%',
				75: '75%',
				100: '100%',
				// 75: {
				//   style: {
				//     color: '#1989FA'
				//   },
				//   label: this.$createElement('strong', '50%')
				// }
			},
			// leverList: [
			// 	{
			// 		text: '5X',
			// 		id: 5
			// 	},
			// 	{
			// 		text: '10X',
			// 		id: 10
			// 	},
			// 	{
			// 		text: '20X',
			// 		id: 20
			// 	},
			// 	{
			// 		text: '50X',
			// 		id: 50
			// 	},
			// 	{
			// 		text: '100X',
			// 		id: 100
			// 	}],
		};
	},
	methods: {
		handleClick() {
			this.zForm.time = ''
			this.dForm.time = ''
		},

		/**
		 * direction 1涨 2跌
		 */
		submit(direction) {
			let formData = this.zForm
			if (direction == 2) {
				formData = this.dForm
			}
			post(apis.contractOrder, {
				...formData,
				direction,
				type: this.type,
				product_id: this.productInfo.id,
				is_stop_profit: formData.is_stop_profit ? 1 : 0,
				is_stop_loss: formData.is_stop_loss ? 1 : 0,
			}).then(res => {
				if (res.code != 1) return
				this.$notify.success(res.msg)
				this.$emit('modify')
				this.$emit('initList')

				if (direction == 1) {
					this.zForm = new FormData(this.lever)
				} else if (direction == 2) {
					this.dForm = new FormData(this.lever)
				}
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.form-page {

	.tip-div {
		margin-top: 16px;
		border-top: 1px solid #31323f;

		.title {
			padding: 16px 0px;
		}

		p {
			font-size: 14px;
			color: #888;
			margin: 0px;
		}
	}

	.form-div {
		.form-item {
			margin-bottom: 10px;

			&.slider-div {
				margin-bottom: 32px;
			}

			.but {
				margin: 22px 0;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
				background-color: #00f0ff;
				color: #000;
				line-height: 46px;
				font-size: 16px;
				border-radius: 30px;

				&.but1 {
					background: #ff4834;
				}
			}

			.label {
				color: #888;
				margin-right: 10px;
			}

			::v-deep .el-input-group__prepend {
				background-color: #ffffff00;
			}

			::v-deep .el-input__inner {
				text-align: right;
				height: 44px;
				line-height: 44px;
				padding-left: 130px;
			}

			::v-deep .el-input-group__append {
				background-color: #00000000;
				min-width: 85px;
				text-align: center;
			}

			.profit_rate_input {
				::v-deep .el-input__inner {
					text-align: left !important;
					padding-left: 15px !important;
				}
			}

			.slot-prepend {
				color: #888;
				display: inline-block;
				width: 130px;
				// padding-left: 10px;
				height: 44px;
				line-height: 44px;
			}

			.slot-suffix {
				color: #888;
				display: inline-block;
				width: 30px;
				// padding-left: 10px;
				height: 44px;
				line-height: 44px;
			}

			::v-deep .el-slider {
				.el-slider__bar {
					background-color: #409eff;
				}

				.el-slider__button {
					border: 2px solid #409eff;
					background-color: #fff;
				}

				.el-slider__stop {
					background-color: #fff;
				}

				.el-slider__runway {
					background-color: #2e3244;
				}
			}
		}
	}
}
</style>